import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { FiHelpCircle } from 'react-icons/fi';

/**
 * ROV 解释 Tooltip 组件
 * 可在任意位置使用，hover 显示 ROV 的计算公式说明
 */
export function RovTooltip({ iconClassName = 'text-slate-500 text-xs' }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = useCallback((event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 8
    });
    setShowTooltip(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowTooltip(false);
  }, []);

  return (
    <>
      <span
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="inline-flex items-center"
      >
        <FiHelpCircle className={`cursor-help hover:text-slate-300 transition-colors ${iconClassName}`} />
      </span>

      {showTooltip && typeof document !== 'undefined' && createPortal(
        (
          <div
            className="fixed rounded-xl bg-slate-900 border border-slate-700 shadow-xl backdrop-blur-xl px-3 py-2 text-xs text-slate-200"
            style={{
              left: `${tooltipPosition.x}px`,
              top: `${tooltipPosition.y}px`,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999
            }}
          >
            <div className="whitespace-nowrap">
              <span className="text-sky-400 font-medium">ROV</span> = 总盈利 / 总交易量
            </div>
            <div className="text-slate-400 mt-1">衡量每单位资金的收益效率</div>
          </div>
        ),
        document.body
      )}
    </>
  );
}
